/**
 * What flipping a template slot's "use default" switch does to the
 * form.
 *
 * The slot's two text fields only apply while the slot is custom, but
 * they stay in the form either way, and the page marks itself unsaved
 * by diffing every field against the loaded account. So a draft typed
 * in custom mode and then abandoned by switching the default back on
 * would leave the page looking changed while nothing about the account
 * had changed.
 *
 * Going back to the default therefore puts both texts back exactly as
 * loaded (`undefined` included — an empty string would read as a
 * change) and parks the draft; going back to custom restores that
 * draft, so switching to and fro loses nothing.
 *
 * Returns the field updates to apply and the drafts to keep; the
 * caller owns both — this function touches nothing.
 */
export const applyDefaultToggle = ({
  row,
  checked,
  values = {},
  initialValues = {},
  drafts = {},
}) => {
  const { firstFieldName, secondFieldName, idDefaultName } = row;
  const updates = { [idDefaultName]: checked };
  const nextDrafts = { ...drafts };

  if (checked) {
    nextDrafts[firstFieldName] = values[firstFieldName];
    nextDrafts[secondFieldName] = values[secondFieldName];
    updates[firstFieldName] = initialValues[firstFieldName];
    updates[secondFieldName] = initialValues[secondFieldName];
  } else {
    if (firstFieldName in nextDrafts) updates[firstFieldName] = nextDrafts[firstFieldName];
    if (secondFieldName in nextDrafts) updates[secondFieldName] = nextDrafts[secondFieldName];
  }

  return { updates, drafts: nextDrafts };
};
